import React, { useState } from "react";
import { motion } from "framer-motion";
import { X, Phone } from "lucide-react";

/**
 * Centered overlay modal matching shipment confirm/form modal shells.
 */
export default function LogActivityModal({ carrierName, onClose, onSave }) {
  const [type, setType] = useState("call");
  const [summary, setSummary] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    if (!summary.trim()) {
      setError("Enter a short activity summary.");
      return;
    }
    onSave({ type, summary: summary.trim() });
  };

  return (
    <motion.div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-40 px-fluid-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="w-full max-w-lg space-y-fluid-4 rounded-2xl bg-white p-fluid-4 shadow-xl dark:bg-acs-dark-surface"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.95 }}
      >
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#E8EFF3] text-[#223688]">
              <Phone size={18} />
            </div>
            <div>
              <h2 className="text-fluid-lg font-semibold text-gray-900 dark:text-acs-dark-text">
                Log Activity
              </h2>
              <p className="text-fluid-sm text-gray-500 dark:text-acs-dark-subtext">
                {carrierName || "Carrier"}
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-acs-dark-text"
          >
            <X size={20} />
          </button>
        </div>

        <div className="space-y-fluid-3 rounded-lg border border-gray-200 bg-gray-50 p-fluid-3 dark:border-acs-dark-border dark:bg-acs-dark-hover">
          <div>
            <label className="mb-1 block text-fluid-sm font-medium text-gray-700 dark:text-acs-dark-text">
              Activity type
            </label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-fluid-sm dark:border-acs-dark-border dark:bg-acs-dark-surface dark:text-acs-dark-text"
            >
              <option value="call">Call</option>
              <option value="email">Email</option>
              <option value="meeting">Meeting</option>
            </select>
          </div>
          <div>
            <label className="mb-1 block text-fluid-sm font-medium text-gray-700 dark:text-acs-dark-text">
              Summary
            </label>
            <textarea
              rows={4}
              value={summary}
              onChange={(e) => {
                setSummary(e.target.value);
                if (error) setError("");
              }}
              placeholder="What was discussed?"
              className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-fluid-sm dark:border-acs-dark-border dark:bg-acs-dark-surface dark:text-acs-dark-text"
            />
            {error ? (
              <p className="mt-1 text-fluid-sm text-red-600">{error}</p>
            ) : null}
          </div>
        </div>

        <div className="flex justify-end gap-fluid-2 border-t border-gray-200 pt-fluid-2 dark:border-acs-dark-border">
          <button
            type="button"
            onClick={onClose}
            className="rounded-full border border-gray-300 px-fluid-button-x py-fluid-button-y text-fluid-sm text-gray-700 hover:bg-gray-100 dark:border-acs-dark-border dark:text-acs-dark-text dark:hover:bg-acs-dark-hover"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="rounded-full bg-[#223688] px-fluid-button-x py-fluid-button-y text-fluid-sm font-semibold text-white hover:bg-[#1E2A74]"
          >
            Save Activity
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
